import { createFileRoute } from '@tanstack/react-router'
import ContactErrorReportList from 'Royalty/components/Reports/ErrorReport/ContactErrorReportList'

export const Route = createFileRoute('/royalty/errorlist/contacts')({
    component: ContactErrorReportList,
})
